/**
 * @generated SignedSource<<2768f6dd8cc8a4a1b32c0cbacb62cba9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type hooksContentHeadlineTagContent$data = {
  readonly flag: string | null;
  readonly sections: ReadonlyArray<{
    readonly value: ReadonlyArray<{
      readonly name: string;
    } | null> | null;
  } | null> | null;
  readonly types?: ReadonlyArray<{
    readonly value: ReadonlyArray<{
      readonly description: {
        readonly text: string | null;
      } | null;
      readonly entityId: string;
      readonly name: string;
    } | null> | null;
  } | null> | null;
  readonly " $fragmentSpreads": FragmentRefs<"hooksContentHelperContent">;
  readonly " $fragmentType": "hooksContentHeadlineTagContent";
};
export type hooksContentHeadlineTagContent$key = {
  readonly " $data"?: hooksContentHeadlineTagContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"hooksContentHeadlineTagContent">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "hooksContentHeadlineTagContent",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "hooksContentHelperContent"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ArticleTypeSegment",
          "kind": "LinkedField",
          "name": "types",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ArticleType",
              "kind": "LinkedField",
              "name": "value",
              "plural": true,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "entityId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "FormattedValue",
                  "kind": "LinkedField",
                  "name": "description",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "text",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Article",
      "abstractKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "flag",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SectionSegment",
      "kind": "LinkedField",
      "name": "sections",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Section",
          "kind": "LinkedField",
          "name": "value",
          "plural": true,
          "selections": [
            (v0/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Content",
  "abstractKey": "__isContent"
};
})();

(node as any).hash = "d2d5c9620782776e59ead8ef00f958ce";

export default node;
